import { Component, Inject, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
  AbstractControl,
  UntypedFormControl,
} from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { validateHTTPExists } from "../../shared/validators/url.validator";
import { ResellerService } from "../reseller.service";
import { ToastrService } from "../../shared/toastr.service";
import { ShowOnSubmitAttemptErrorStateMatcher } from "../../shared/error-state-matcher";
import {
  AddResellerClientRequest,
  AddResellerClientDialogData,
} from "../reseller.interface";

@Component({
  selector: "app-add-reseller-client-dialog",
  templateUrl: "./add-reseller-client-dialog.component.html",
  styleUrls: ["./add-reseller-client-dialog.component.scss"],
  standalone: false,
})
export class AddResellerClientDialogComponent implements OnInit {
  form: FormGroup;
  loading = false;
  errorStateMatcher = new ShowOnSubmitAttemptErrorStateMatcher();

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<AddResellerClientDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AddResellerClientDialogData,
    private translate: TranslateService,
    private resellerService: ResellerService,
    private toastrService: ToastrService,
  ) {
    this.form = this.fb.group({
      domain: [
        "",
        [
          (c: AbstractControl) => Validators.required(c),
          (c: AbstractControl) => validateHTTPExists(c as UntypedFormControl),
        ],
      ],
      googleAdminEmail: ["", (c: AbstractControl) => Validators.required(c)],
      trialFinishDate: [null, (c: AbstractControl) => Validators.required(c)],
      isIncludedDemoContent: [false],
    });
  }

  ngOnInit(): void {}

  onSubmit(): void {
    this.errorStateMatcher.submitAttempted = true;
    if (this.form.invalid || this.loading) {
      return;
    }

    this.loading = true;
    const formValue = this.form.value as AddResellerClientRequest;

    const request: AddResellerClientRequest = {
      domain: formValue.domain,
      googleAdminEmail: formValue.googleAdminEmail,
      trialFinishDate: formValue.trialFinishDate,
      isIncludedDemoContent: formValue.isIncludedDemoContent,
    };

    this.resellerService
      .addClient(this.data.resellerDomain, request)
      .subscribe({
        next: () => {
          this.loading = false;
          this.toastrService.success(
            this.translate.instant("reseller.addClientSuccess") as string,
          );
          this.dialogRef.close(true);
        },
        error: () => {
          this.loading = false;
          this.toastrService.error(
            this.translate.instant("reseller.addClientError") as string,
          );
        },
      });
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
